import { ActivatedRouteSnapshot, BaseRouteReuseStrategy } from "@angular/router";

export class ConfigurableRouteReuseStrategy extends BaseRouteReuseStrategy {

  override shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {

    if (typeof future.data['shouldReuse'] == 'boolean') {
      return future.data['shouldReuse'];
    }

    return super.shouldReuseRoute(future, curr)
  }

}
